export const SelectTheme = {
  variants: {
    outline: {
      field: {
        background: 'brand.formInputBgColor',

        _focus: {
          borderColor: 'brand.fontColor',
          boxShadow: `0 0 0 1px brand.offBlack`,
        },

        _invalid: {
          borderColor: 'brand.pink',
          boxShadow: '0 0 0 1px brand.pink',
        },
      },
      icon: {
        color: 'brand.fontColor',
        svg: {
          background: 'brand.white',
          borderRadius: "50%",
        }
      }
    },
  },
  defaultProps: {
    size: 'lg'
  }
}